import { el, mount, unmount } from 'redom';

import { decorateWithShowHide } from 'decorators/ui';

class CancelButton {

  constructor(configuration) {

    this.label = configuration.label;
    this.onClick = configuration.onClick;

    this.el = el('button', {
      type: 'button',
      class: 'delete-button',
      id: configuration.id || 'delete-button-' + Date.now(),
      onclick: this.onClick
    }, this.label);

  }

  update(configuration) {

    this.el.textContent = configuration.label;

  }

}

export default decorateWithShowHide(CancelButton);